import { EventHandler } from 'playcanvas';

type FunctionCallback = (...args: any[]) => any;

class Events extends EventHandler {
    functions = new Map<string, FunctionCallback>();

    log = false;

    fire(name: string,arg1?: any,arg2?: any,arg3?: any,arg4?: any,arg5?: any,arg6?: any,arg7?: any,arg8?: any) {
    	super.fire(name,arg1,arg2,arg3,arg4,arg5,arg6,arg7,arg8);
    	if ("EVENT",this.log) console.log(name,arg1,arg2,arg3,arg4,arg5,arg6,arg7,arg8);
    }

    // declare an editor function
    function(name: string, fn: FunctionCallback) {
        if (this.functions.has(name)) {
            throw new Error(`error: function ${name} already exists`);
        }
        this.functions.set(name, fn);
    }

    // invoke an editor function
    invoke(name: string, ...args: any[]) {
        const fn = this.functions.get(name);
        if (!fn) {
            console.log(`error: function not found '${name}'`);
            return;
        }
        return fn(...args);
    }
}

export { Events };
